export default __webpack_public_path__ + "static/media/epigro_mobile_2.f94669a3.png";